<div class="relative container mx-auto mt-12 space-y-8">
  <div
    class="flex flex-col gap-2 rounded-xl p-4 ring-1 ring-zinc-900/15 md:p-8 dark:ring-white/10"
  >
    <h1 class="pb-4 text-3xl text-zinc-900 dark:text-zinc-200">
      Review Survey
    </h1>
    <p>Please take the time to review you have completed the entire survey.</p>
  </div>
  <h2
    *ngIf="completed"
    class="pt-10 text-center text-4xl text-zinc-900 dark:text-zinc-200"
  >
    Thanks for taking the Survey!
  </h2>
  <h2 *ngIf="!completed" class="pt-4 text-3xl text-zinc-900 dark:text-zinc-200">
    Review
  </h2>
  <div *ngIf="!completed" class="overflow-x-auto">
    <table class="w-full table-auto border-separate border border-zinc-600">
      <thead class="bg-zinc-300 dark:bg-zinc-700">
        <tr>
          <th
            *ngFor="let head of headers"
            scope="col"
            class="border border-zinc-600 px-2 py-1 dark:border-white/10"
          >
            {{ head }}
          </th>
        </tr>
      </thead>
      <ng-container *ngIf="pages$ | async; let pages">
        <tbody *ngIf="pages.length > 0; else noItems">
          <tr
            *ngFor="
              let page of pages | paginate: { itemsPerPage: 10, currentPage: p }
            "
          >
            <td>{{ page.Title }}</td>
            <td class="text-cam-red">Incomplete</td>
            <td>
              <button
                class="cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none"
                (click)="onNavigate(page)"
              >
                Finish
              </button>
            </td>
          </tr>
        </tbody>
      </ng-container>
    </table>
    <div class="flex justify-center pt-4">
      <pagination-controls (pageChange)="p = $event"></pagination-controls>
    </div>
  </div>
</div>

<ng-template #noItems>
  <td colspan="8" class="text-center">
    <h5>{{ message }}</h5>
    <button
      class="cursor-pointer justify-center rounded-lg bg-green-700 px-3 py-2 font-semibold text-white outline-offset-2 transition hover:bg-green-600 active:bg-green-700 active:text-green-100/70 active:transition-none"
      (click)="submitSurvey()"
    >
      SUBMIT SURVEY
    </button>
  </td>
</ng-template>
